import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UserTransactionStat {
  slug: string
  label: string
  value: number
}

export function getUserTransactionStatsAction(userUuid: string): Promise<ApiResponse<UserTransactionStat[]>> {
  const url = `/statistics/user/${userUuid}/transactions`
  return api.get<ApiResponse<UserTransactionStat[]>>(url)
}
